/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

// Angular
import { Component, Input } from '@angular/core';

import { UserProfile } from '../../models/user';

@Component({
	selector: 'celine-threshold-user-profile-switch-item',
	template: require('./user-profile-switch-item.component.html')
})

export class UserProfileSwitchItemComponent {

    @Input('userProfile') userProfile: UserProfile;

    featTogLocalization = process.env.config.feature.localization.enabled;

    constructor() { }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/user/user-profile-switch-item.component.ts